import { useContext } from 'react';
import { ThemeContext, ThemeType } from './themeContext';

export { ThemeType };

export const useHeaderTheme = () => {
  const theme = useContext(ThemeContext);
  return theme;
};
